import { Button, Modal, Form, Input, Tag, Spin, message, Row, Col } from "antd";
import React, { useState,useEffect } from "react";
import { GiftOutlined } from "@ant-design/icons";
import { shareCouponCode } from "./../../services";

import QRModel from "./../../components/QRModel";

const COUPON_REDEEM_URL =
  "https://dev-plans.projectdasein.com/coupon-redeem?coupon_status=true&coupon_code=";
const CouponModal = ({ data, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [couponData, setData] = useState(data);

  const [qrCodeBase64, setQRCodeBase64] = useState(null);

  // Handler for receiving base64 image
  const handleQRCodeGenerated = (base64) => {
    setQRCodeBase64(base64); // Set the base64 image URL to state or use it elsewhere
  };

  const [form] = Form.useForm(); // Initialize the form instance

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    form.submit(); // Trigger form submission on "OK" click
  };

  const handleCancel = () => {
    onClose(false);
    // setIsModalOpen(false);
    form.resetFields(); // Reset form fields when modal is closed
  };

  const onFinish = async (values) => {
    setLoading(true);
    couponData.qrcode = qrCodeBase64;
    values.coupon_info = JSON.stringify(couponData);
    values.type = 'coupon-recipient';
    console.log("Form values:", values);

    const couporResponse = await shareCouponCode(values);
    console.log(couporResponse);

    if (couporResponse.status) {
      message.success(couporResponse.message);

      if(localStorage.getItem("gift_share") && localStorage.getItem("gift_share")!=""){
          localStorage.removeItem("gift_share");
      }

    } else {
      message.warning(couporResponse.message);
    }

    form.resetFields();
    setLoading(false);
    onClose(false);
    // setIsModalOpen(false); // Close modal after form submission
  };


  console.log(couponData);

  return (
    <>
      <Modal

        title="Send an email to the recipient."

        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="dashboard_modal"
      >
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish} // Handle form submission
          >
            <Row>
              <Col span={12}>
                <Tag
                  icon={<GiftOutlined style={{ fontSize: "20px" }} />}
                  color="success"
                >
                  <h1> {couponData.id} </h1> 
                </Tag>
              </Col>
              <Col span={12}>
                <QRModel
                  couponId={`${COUPON_REDEEM_URL}${couponData.id}`}
                  onQRCodeGenerated={handleQRCodeGenerated}
                />

                {qrCodeBase64 && (
                  <div>
                    <img
                      style={{ height: "150px", borderRadius: "10px" }}
                      src={qrCodeBase64}
                      alt="QR Code"
                    />
                  </div>
                )}
              </Col> 
            </Row>

            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter your name!" }]}
            >
              <Input placeholder="Enter name " />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Please enter a valid email!" },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>
{/* 
            <Form.Item
              label="Description"
              name="description"
              rules={[
                { required: false, message: "Please enter a description!" },
              ]}
            >
              <Input.TextArea rows={2} placeholder="Enter description" />
            </Form.Item> */}
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default CouponModal;
